import React from 'react';
import { BrowserRouter, Route, Routes, } from 'react-router-dom';
import './App.css';
import SalesDashboard from './SalesDashboard';
import { AuthProvider } from './providers/AuthProvider';
import { PermissionProvider, usePermission } from './permission/PermissionContext';
import { ConfigProvider, Layout } from 'antd';
import { Header } from './components/Header';
import Loader from './components/common/Loader';
import Unauthorized from './components/Unauthorized/Unauthorized';
import PageTitle from './components/common/PageTitle';
import BroadcastWrapper from './components/common/BroadcastWrapper';
import { UserProvider } from './components/context/userContext';
import BroadcastDemoPage from './pages/BroadcastDemoPage';

const { Content } = Layout;


interface ProtectedRouteProps {
    element: React.ReactElement;
    permissionKey: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element, permissionKey }) => {
    const permissionResult = usePermission(permissionKey);

    if (permissionResult === 'loading') return <Loader />;
    if (permissionKey && !permissionResult) return <Unauthorized />;

    return element;
};

function App() {
    return (
        <BrowserRouter>
            <ConfigProvider
                theme={{
                    token: {
                        colorPrimary: "#6c5ffc",
                        fontFamily: 'IBM Plex Sans, sans-serif'
                    }
                }
                }>
                <AuthProvider>
                    <PermissionProvider>
                        <UserProvider>
                            <BroadcastWrapper>
                                <Layout className="min-h-screen">
                                    <Header />
                                    <Content className="main p-4">
                                        <Routes>
                                            <Route path="/" element={
                                                <>
                                                    <PageTitle title="Sales Dashboard" />
                                                    <ProtectedRoute element={<SalesDashboard />} permissionKey="sales_dashboard" />
                                                </>
                                            } />
                                            <Route path="/broadcast-demo" element={<BroadcastDemoPage />} />
                                        </Routes>
                                    </Content>
                                </Layout>
                            </BroadcastWrapper>
                        </UserProvider>
                    </PermissionProvider>
                </AuthProvider>
            </ConfigProvider>
        </BrowserRouter>
    );
}

export default App;
